import { COMPANIES } from 'constants/Entities';
import BASE_CONFIG from 'containers/companies/EntityConfig';
import { getMarketingStatusColumn } from 'components/TableCells/MarketingStatusCell/column';
import { setMarketingConsentAccount } from 'services/MarketingConsentService';

const ALLOWED_COLS = ['name', 'responsible', 'companytype', 'email1'];

export default ({ onClickCheckbox, selectionToken, spamchimp, canEdit } = {}) => {
    const tableParams = {
        ...(onClickCheckbox ? { account: { onClickCheckbox } } : {}),
        spamchimp,
        ...(canEdit !== undefined ? { canEdit } : {}),
    };
    const base = BASE_CONFIG(tableParams);

    const marketingColumn = getMarketingStatusColumn({
        minWidth: 160,
        setMarketingConsent: setMarketingConsentAccount,
    });

    return {
        ...base,
        useFiltersDrawer: false,
        filterKey: 'recipientsAccounts',
        quickFilters: [
            'marketingStatus',
            ...base.quickFilters.filter((id) => id !== 'marketingStatus'),
        ],
        columnSelectorSections: undefined,
        withEntitySelection: true,
        selectionFor: 'marketingCampaigns',
        selectionEntity: 'accounts',
        selectionToken,
        isLocalSelection: false,
        columnDefs: [
            ...base.columnDefs
                .filter((col) => ALLOWED_COLS.includes(col.colId))
                .map(({ width, suppressSizeToFit, ...col }) => ({ ...col, minWidth: width })),
            marketingColumn,
        ],
    };
};
